class SkinConcernsSlider {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.slider = document.getElementById(`skin-concerns-slider-${sectionId}`);
    this.pagination = document.getElementById(`skin-concerns-pagination-${sectionId}`);
    this.autoScrollInterval = null;
    this.autoScrollDelay = 3000; // 3 seconds between slides
    
    if (!this.slider || !this.pagination) return;

    this.dots = this.pagination.querySelectorAll('.jiyu-skin-concerns__dot');
    this.cards = this.slider.querySelectorAll('.jiyu-skin-concerns__card-wrapper');
    
    if (this.cards.length === 0) return;

    this.init();
  }

  init() {
    this.setupEventListeners();
    this.updateActiveDot();
    
    // Start auto-scroll only on mobile devices
    if (this.isMobile()) {
      this.startAutoScroll();
      
      // Pause auto-scroll on user interaction
      this.slider.addEventListener('touchstart', () => this.stopAutoScroll());
      this.slider.addEventListener('touchend', () => {
        setTimeout(() => this.startAutoScroll(), 5000); // Resume after 5s
      });
    }
  }

  isMobile() {
    return window.innerWidth <= 768;
  }

  updateActiveDot() {
    const scrollLeft = this.slider.scrollLeft;
    const cardWidth = this.cards[0].offsetWidth + 16; // card width + gap
    const currentIndex = Math.round(scrollLeft / cardWidth);
    
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentIndex);
    });
  }
scrollToCard(index) {
  const cardWidth = this.cards[0].offsetWidth + 16;
  this.slider.scrollTo({
    left: index * cardWidth,
    behavior: 'smooth'
  });
}

  setupEventListeners() {
    // Scroll to card when dot is clicked
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.scrollToCard(index);
        this.updateActiveDot();
        
        // Reset auto-scroll timer on manual interaction
        if (this.isMobile()) {
          this.stopAutoScroll();
          setTimeout(() => this.startAutoScroll(), 5000);
        }
      });
    });

    // Update dots on scroll
    this.slider.addEventListener('scroll', () => this.updateActiveDot());

    // Handle window resize
    window.addEventListener('resize', () => {
      if (this.isMobile() && !this.autoScrollInterval) {
        this.startAutoScroll();
      } else if (!this.isMobile() && this.autoScrollInterval) {
        this.stopAutoScroll();
      }
    });
  }

  startAutoScroll() {
    this.stopAutoScroll(); // Clear any existing interval
    
    this.autoScrollInterval = setInterval(() => {
      const scrollLeft = this.slider.scrollLeft;
      const cardWidth = this.cards[0].offsetWidth + 16;
      const currentIndex = Math.round(scrollLeft / cardWidth);
      const nextIndex = (currentIndex + 1) % this.cards.length;
      
      this.scrollToCard(nextIndex);
    }, this.autoScrollDelay);
  }

  stopAutoScroll() {
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    }
  }
}

// Initialize all skin concerns sliders on the page
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('[id^="section-"]');
  
  sections.forEach(section => {
    if (section.classList.contains('jiyu-skin-concerns')) {
      const sectionId = section.id.replace('section-', '');
      new SkinConcernsSlider(sectionId);
    }
  });
});

// Handle Shopify theme editor
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target;
    if (section.classList.contains('jiyu-skin-concerns')) {
      const sectionId = section.id.replace('section-', '');
      new SkinConcernsSlider(sectionId);
    }
  });
}